
<template>
  <div>
    <el-dialog :visible.sync="crisiscasesdialog" :before-close="cancellation" width="60%">
      <el-form :model="risiscasesData" ref="risiscasesData">
        <el-form-item style="text-align: center;padding: 10px 0;"><span style="font-weight: bold;font-size: 20px;">危机个案上报</span></el-form-item>
        <el-form-item style="border-bottom: 1px solid #d0d0d0;padding-bottom: 20px;">
          <el-row>
            <el-col :span="7">
              <label>咨询师</label><br/>
              <el-input v-model.trim="risiscasesData.TeachID" disabled style="width: 100%"></el-input>
            </el-col>
            <el-col :span="7" :offset="1">
              <label>{{SourceFlg!='4'?'评估时间':'咨询时间'}}</label><br/>
              <el-date-picker v-if="SourceFlg!='4'" :disabled="isEdit" v-model="risiscasesData.EvaluationTime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"> </el-date-picker>
              <el-input v-else v-model="risiscasesData.RecordTime" disabled></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item style="font-size: 22px;font-weight:bold;margin-top: 10px;">基本信息</el-form-item>
        <el-form-item>
          <el-row>
            <el-col :span="7">
              <label>姓名</label>
              <el-input v-model="UserName" disabled></el-input>
            </el-col>
            <el-col :span="7" :offset="1">
              <label>学号</label>
              <el-input v-model="risiscasesData.UserID" disabled></el-input>
            </el-col>
            <el-col :span="7" :offset="1">
              <label>所在院系/研究所</label>
              <el-input v-model="risiscasesData.DeptName" disabled></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="7">
              <label>导师/心理辅导员联系方式</label>
              <el-input v-model="risiscasesData.Phone" disabled placeholder="请输入"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item style="font-size: 22px;font-weight:bold;margin-top: 10px;">危机评估</el-form-item>
        <el-form-item>
          <label>意识（是否清醒，是否服用药物/精神活性物质，现实检验力等）</label>
          <el-input type="textarea" v-model="risiscasesData.Awareness" placeholder="请输入概要描述事件，不透露隐私内容" maxlength="500" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <label>所处情境（所处位置/周围环境）</label>
          <el-input type="textarea" v-model="risiscasesData.Situations" placeholder="请输入" maxlength="500" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <label>自知力</label>
          <el-input type="textarea" v-model="risiscasesData.Insight" placeholder="请输入" maxlength="500" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <label>情绪状态（类型/强度等）</label>
          <el-input type="textarea" v-model="risiscasesData.EmotionalState" placeholder="请输入" maxlength="500" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <label>主要压力源（应激事件/应激反应）</label>
          <el-input type="textarea" v-model="risiscasesData.PressureSource" placeholder="请输入" maxlength="500" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item style="font-size: 22px;font-weight:bold;margin-top: 30px;"><span style="color: red;">*</span>风险等级</el-form-item>
        <el-form-item
        prop="FirstCrisis"
        :rules="{ required: true, message: '请选择风险等级', trigger: ['change'] }"
    >
          <el-radio v-model="risiscasesData.FirstCrisis" label="1" :disabled="!canEditFirstCrisis && isEdit">五级/严重而紧急</el-radio>
          <el-radio v-model="risiscasesData.FirstCrisis" label="2" :disabled="!canEditFirstCrisis && isEdit">四级/重度</el-radio>
          <el-radio v-model="risiscasesData.FirstCrisis" label="3" :disabled="!canEditFirstCrisis && isEdit">三级/中度</el-radio>
          <el-radio v-model="risiscasesData.FirstCrisis" label="4" :disabled="!canEditFirstCrisis && isEdit">二级</el-radio>
          <el-radio v-model="risiscasesData.FirstCrisis" label="5" :disabled="!canEditFirstCrisis && isEdit">一级</el-radio>
        </el-form-item>
        <el-form-item style="font-size: 22px;font-weight:bold;margin-top: 10px;">具体风险等级</el-form-item>
        <el-form-item>
          <el-row>自杀、自伤或伤害他人倾向</el-row>
          <el-row>
            <el-radio v-model="risiscasesData.SuicidalFlg" label="1" :disabled="isEdit">是</el-radio>
            <el-radio v-model="risiscasesData.SuicidalFlg" label="0" :disabled="isEdit">否</el-radio>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-row>自杀、自伤或伤害他人倾向</el-row>
          <el-row>
            <el-checkbox-group v-model="Damage" @change="handleCheckedDamageChange" :disabled="isEdit">
              <el-checkbox v-for="item in DamageList" :label='`{"dicKey":"${item.dicKey}","cdicvalue":"${item.cDicValue}"}`' :key="item.dicKey">
                {{item.cDicValue}}
                <el-input v-model="Damageother" v-if="item.cDicValue=='其他'" :disabled="isEdit" @blur="handleCheckedDamageChange(Damage)" maxlength="50" show-word-limit></el-input>
              </el-checkbox>
            </el-checkbox-group>
          </el-row>
        </el-form-item>
        <el-form-item>

          <el-row>关于自杀的方式</el-row>
          <el-row>
            <el-checkbox-group v-model="SuicideMethods" @change="handleCheckedSuicideMethodsChange" :disabled="isEdit">
              <el-checkbox v-for="item in SuicideMethodsList" :label='`{"dicKey":"${item.dicKey}","cdicvalue":"${item.cDicValue}"}`' :key="item.dicKey">
                {{item.cDicValue}} 
                <el-input v-model="SuicideMethodsother" :disabled="isEdit" v-if="item.cDicValue=='其他'" @blur="handleCheckedSuicideMethodsChange(SuicideMethods)" maxlength="50" show-word-limit></el-input>
              </el-checkbox>

            </el-checkbox-group>
          </el-row>

        </el-form-item>
        <el-form-item>
          <label>既往自杀相关经历（来访者/重要关系人）</label>
          <el-input type="textarea" v-model="risiscasesData.InjuryExperience" placeholder="请输入" maxlength="100" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <label>具体描述时间、情况、进程等</label>
          <el-input type="textarea" v-model="risiscasesData.SpecificTimeOne" placeholder="请输入" maxlength="100" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <el-row>疑似重性精神障碍</el-row>
          <el-row>
            <el-radio v-model="risiscasesData.PsychosesFlg" label="1" :disabled="isEdit">是</el-radio>
            <el-radio v-model="risiscasesData.PsychosesFlg" label="0" :disabled="isEdit">否</el-radio>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-row>疑似出现</el-row>
          <el-row>
            <el-checkbox-group v-model="SuspectedAppear" @change="handleCheckedSuspectedAppearChange" :disabled="isEdit">
              <el-checkbox v-for="item in SuspectedAppearList" :label='`{"dicKey":"${item.dicKey}","cdicvalue":"${item.cDicValue}"}`' :key="item.dicKey">
                {{item.cDicValue}}
              </el-checkbox>
            </el-checkbox-group>
          </el-row>
        </el-form-item>
        <el-form-item>
          <label>具体描述时间、情况、进程等</label>
          <el-input type="textarea" v-model="risiscasesData.SpecificTimeTwo" placeholder="请输入" maxlength="100" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item style="font-size: 22px;font-weight:bold;margin-top: 10px;">基本信息</el-form-item>
        <el-form-item>
          <label>时间/医院/医师/诊断</label>
          <el-input type="textarea" v-model="risiscasesData.Timelocation" placeholder="请输入" maxlength="100" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <label>服药情况（药名 药量 是否遵医嘱服药）</label>
          <el-input type="textarea" v-model="risiscasesData.MedicineDescribe" placeholder="请输入" maxlength="500" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item style="font-size: 22px;font-weight:bold;margin-top: 10px;">社会支持系统情况</el-form-item>
        <el-form-item>
          <label>如：最信赖的人，与父母、朋友、导师的关系等</label>
          <el-input type="textarea" v-model="risiscasesData.SocialSupport" placeholder="请输入" maxlength="500" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item style="font-size: 22px;font-weight:bold;margin-top: 10px;">咨询师综合印象及建议</el-form-item>
        <el-form-item>
          <label>整体印象（对心理症状类型的评估及评估依据）</label>
          <el-input type="textarea" v-model="risiscasesData.OverallImpression" placeholder="请输入需包含社会支持系统概要情况" maxlength="100" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <label>建议（长期咨询/通知家长/建议就医/遵医嘱服药）</label>
          <el-input type="textarea" v-model="risiscasesData.Recommendation" placeholder="请输入" maxlength="100" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item style="font-size: 22px;font-weight:bold;margin-top: 10px;">填表说明</el-form-item>
        <el-form-item>
          <el-row>感觉疑似出现</el-row>
          <el-row>
            <el-checkbox-group v-model="SensoryProblems" @change="handleCheckedSensoryProblemsChange" :disabled="isEdit">
              <el-checkbox v-for="item in SensoryProblemsList" :label='`{"dicKey":"${item.dicKey}","cdicvalue":"${item.cDicValue}"}`' :key="item.dicKey">
                {{item.cDicValue}}
              </el-checkbox>
            </el-checkbox-group>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-row>思维疑似出现</el-row>
          <el-row>
            <el-checkbox-group v-model="ThinkProblems" @change="handleCheckedThinkProblemsChange" :disabled="isEdit">
              <el-checkbox v-for="item in ThinkProblemsList" :label='`{"dicKey":"${item.dicKey}","cdicvalue":"${item.cDicValue}"}`' :key="item.dicKey">
                {{item.cDicValue}}
              </el-checkbox>
            </el-checkbox-group>
          </el-row>
        </el-form-item>
        <!--这是不确定咨询师评估后提交给的咨询主管初审-->
        <div v-if="pageNum==-3">
          <div v-if="this.Global.pdroleid(1066)">
            <el-form-item class="bgfbf2" label="">
              <el-row>咨询主管初审</el-row>
              <el-row>
                <el-checkbox-group :max="3" v-model="paramscrisis.consultDirectorChecks" :disabled="!this.Global.pdroleid(1066) || pageNum==-2">
                  <el-checkbox label="1" name="type">信息不完整</el-checkbox>
                  <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
                  <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
                  <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
                </el-checkbox-group>
              </el-row>
            </el-form-item>

            <el-form-item>
              <el-input type="textarea" v-model="paramscrisis.consultDirectorCheckDetail" :disabled="!this.Global.pdroleid(1066) || pageNum==-2" maxlength="500" show-word-limit></el-input>
            </el-form-item>

            <el-form-item style="margin: 20px 0;" v-if="this.Global.pdroleid(1066) && pageNum!=-2">
              <el-button type="danger" @click="handleSubmit('3')">驳回</el-button>
              <el-button type="primary" @click="handleSubmit('1')" style="margin-left: 30px;">{{ auditPrimarySubmitText }}</el-button>
            </el-form-item>
          </div>
        </div>
        <!--咨询主管定级审核内容-->
        <el-form-item v-if="showConsultDirectorReview" label="咨询主管审核内容" class="nkjs">
          <el-input
            type="textarea"
            v-model="consultDirectorReviewDetail"
            :disabled="disabledConsultDirectorReview"
            :placeholder="disabledConsultDirectorReview ? '' : '请输入咨询主管审核内容'">
          </el-input>
        </el-form-item>
        <!-- 定级审核内容（参照 Crisis_lookreport：风险监控员 / 危机主管/ 心理中心主任） -->
        <el-form-item v-if="showRiskMonitorReview" label="风险监控员审核内容" class="nkjs">
          <el-input
            type="textarea"
            v-model="riskMonitorReviewDetail"
            :disabled="disabledRiskMonitorReview"
            :placeholder="disabledRiskMonitorReview ? '' : '请输入风险监控员审核内容'">
          </el-input>
        </el-form-item>
        <el-form-item v-if="showCriAdminReview" label="危机主管审核内容" class="nkjs">
          <el-input
            type="textarea"
            v-model="criAdminReviewDetail"
            :disabled="disabledCriAdminReview"
            :placeholder="disabledCriAdminReview ? '' : '请输入危机主管审核内容'">
          </el-input>
        </el-form-item>
        <el-form-item v-if="showCenterDirectorReview" label="心理中心主任审核内容" class="nkjs">
          <el-input
            type="textarea"
            v-model="centerDirectorReviewDetail"
            :disabled="disabledCenterDirectorReview"
            :placeholder="disabledCenterDirectorReview ? '' : '请输入心理中心主任审核内容'">
          </el-input>
        </el-form-item>
        <!-- 办理内容输入框 -->
        <!-- type=2时：1068和1069可以看到两个输入框，但只能编辑自己的内容，另一个是查看显示 -->
        <!-- type不传值时：1068、1069、1070可以看到两个输入框，有内容就显示，没有就隐藏，都是只读 -->
        
        <!-- 危机主管办理内容 -->
        <el-form-item v-if="showCrisisAdminHandleContentDisplay" label="危机主管办理内容" class="nkjs">
          <el-input 
            type="textarea" 
            v-model="criAdminHandleDetail" 
            :disabled="!canEditCrisisAdminHandleContent"
            :placeholder="canEditCrisisAdminHandleContent ? '请输入危机主管办理内容' : ''" >
          </el-input>
        </el-form-item>
        
        <!-- 风险监控员办理内容 -->
        <el-form-item v-if="showRiskMonitorHandleContentDisplay" label="风险监控员办理内容" class="nkjs">
          <el-input 
            type="textarea" 
            v-model="riskMonitorHandleDetail" 
            :disabled="!canEditRiskMonitorHandleContent"
            :placeholder="canEditRiskMonitorHandleContent ? '请输入风险监控员办理内容' : ''" >
          </el-input>
        </el-form-item>
        
        <!-- 办理提交按钮（type=2时显示） -->
        <div v-if="showHandleSubmitBtn" style="text-align: center; margin-top: 20px; margin-bottom: 20px;">
          <el-button type="primary" @click="handleHandleSubmit()">确定</el-button>
        </div>
        
        <!-- 审核按钮（type=1时显示） -->
        <div v-if="showSubmitAndRejectBtns" style="text-align: center; margin-top: 20px; margin-bottom: 20px;">
          <el-button type="danger" @click="handleReject">驳回</el-button>
          <el-button type="primary" @click="handleSubmit('1')" style="margin-left: 30px;">{{ auditPrimarySubmitText }}</el-button>
          <!-- 1068: 显示审核确认按钮 -->
          <el-button v-if="showFinalSubmitBtn" type="success" @click="handleSubmit('2')" style="margin-left: 30px;">审核确认</el-button>
        </div>
      </el-form>
      <div style="text-align: right;margin: 30px 0;" v-if="pageNum>=0">
        <el-button @click="canceldia">取 消</el-button>
        <el-button v-if="SourceFlg=='4'" type="primary" @click="confirmClick(2)" :disabled="isEdit">保 存</el-button>
        <el-button type="primary" @click="confirmClick(1)" :disabled="isEdit">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name:"Crisiscases",
  data(){
    return{
      RoleID:sessionStorage.getItem('RoleID'),
      crisiscasesdialog:false,
      UserName:'',
      SourceFlg:'',
      reportStatus:'',
      urgentStatus:'',
      Reporttype:'',
      estimate:true,
      risiscasesData: {
        Type:'1',//1.提交   2.保存
        TeachID:'',
        RecordTime:'',
        RealName:'',
        UserID:'',
        Phone:'',
        DeptName:'',
        Awareness:'',
        Situations:'',
        Insight:'',
        EmotionalState:'',
        PressureSource:'',
        FirstCrisis:'',
        InjuryTendency:[],
        SuicideMethods:[],
        InjuryExperience:'',
        SpecificTimeOne:'',
        PsychosesFlg:'',
        SuspectedAppearance:[],
        SpecificTimeTwo:'',
        Timelocation:"",
        MedicineDescribe:'',
        SocialSupport:'',
        OverallImpression:'',
        Recommendation:'',
        SensoryProblems:[],
        ThinkProblems:[],
        KeyNo:'',
        EvaluationTime:''
      },
      Damage:[],
      DamageList:[],
      Damageother:'',
      SuicideMethods:[],
      SuicideMethodsList:[],
      SuicideMethodsother:'',
      SuspectedAppear:[],
      SuspectedAppearList:[],
      SensoryProblems:[],
      SensoryProblemsList:[],
      ThinkProblems:[],
      ThinkProblemsList:[],
      isEdit:true,
      pageNum:0,
      type: '', // 类型参数：'1'=审核, '2'=办理, 不传=查看
      criAdminHandleDetail: '', // 危机主管办理内容（1068）
      riskMonitorHandleDetail: '', // 风险监控员办理内容（1069）
      riskMonitorReviewDetail: '', // 风险监控员定级审核内容（1069）
      criAdminReviewDetail: '', // 危机主管定级审核内容（1068）
      centerDirectorReviewDetail: '', // 心理中心主任定级审核内容（1070）
      consultDirectorReviewDetail:'',//咨询主管审核内容
      paramscrisis:{
        keyNo:'',
        type:'咨询上报',
        Operate:'',
        riskMonitorChecks:[],
        consultDirectorChecks:[],
        riskMonitorCheckDetail:'',
        consultDirectorCheckDetail:'',
        criAdminChecks:[],
        criAdminCheckDetail:'',
        centerDirectorChecks:[],
        centerDirectorCheckDetail:''
      },

    }
  },
  computed: {
    // 判断是否显示危机主管办理内容输入框
    showCrisisAdminHandleContentDisplay() {
      if (this.type === '2') {
        // type=2时，1068和1069都显示
        return (this.RoleID && this.RoleID.indexOf('1068') !== -1) || 
               (this.RoleID && this.RoleID.indexOf('1069') !== -1);
      } else if (!this.type || this.type === '') {
        // type不传值时，1068、1069、1070显示，但需要有内容才显示
        const hasRole = (this.RoleID && this.RoleID.indexOf('1068') !== -1) ||
                        (this.RoleID && this.RoleID.indexOf('1069') !== -1) ||
                        (this.RoleID && this.RoleID.indexOf('1070') !== -1);
        return hasRole && this.criAdminHandleDetail && this.criAdminHandleDetail.trim();
      }
      return false;
    },
    // 判断是否显示风险监控员办理内容输入框
    showRiskMonitorHandleContentDisplay() {
      if (this.type === '2') {
        // type=2时，1068和1069都显示
        return (this.RoleID && this.RoleID.indexOf('1068') !== -1) || 
               (this.RoleID && this.RoleID.indexOf('1069') !== -1);
      } else if (!this.type || this.type === '') {
        // type不传值时，1068、1069、1070显示，但需要有内容才显示
        const hasRole = (this.RoleID && this.RoleID.indexOf('1068') !== -1) ||
                        (this.RoleID && this.RoleID.indexOf('1069') !== -1) ||
                        (this.RoleID && this.RoleID.indexOf('1070') !== -1);
        return hasRole && this.riskMonitorHandleDetail && this.riskMonitorHandleDetail.trim();
      }
      return false;
    },
    // 判断是否可以编辑危机主管办理内容（type=2时，只有1068可以编辑）
    canEditCrisisAdminHandleContent() {
      return this.type === '2' && this.RoleID && this.RoleID.indexOf('1068') !== -1;
    },
    // 判断是否可以编辑风险监控员办理内容（type=2时，只有1069可以编辑）
    canEditRiskMonitorHandleContent() {
      return this.type === '2' && this.RoleID && this.RoleID.indexOf('1069') !== -1;
    },
    // 判断是否显示办理提交按钮（type=2时，1068或1069显示）
    showHandleSubmitBtn() {
      if (this.type !== '2') return false;
      return (this.RoleID && this.RoleID.indexOf('1068') !== -1) || 
             (this.RoleID && this.RoleID.indexOf('1069') !== -1);
    },
    /** 咨询主管定级页只读查看链路上已填写的审核意见 */
    gradingConsultDirectorViewAudit() {
      return (
        this.type === '1' &&
        this.Global &&
        this.Global.pdroleid(1066) &&
        (this.pageNum === -1 || this.pageNum === -3)
      );
    },
    showConsultDirectorReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      const isView = !this.type || (this.type !== '1' && this.type !== '2');
      const isConsultationReport = this.paramscrisis && this.paramscrisis.type === '咨询上报';
      const hasAuditRole = this.RoleID && (
        this.RoleID.indexOf('1066') !== -1 ||
        this.RoleID.indexOf('1069') !== -1 ||
        this.RoleID.indexOf('1068') !== -1 ||
        this.RoleID.indexOf('1070') !== -1
      );
      const canView = isConsultationReport && this.RoleID && (
        this.RoleID.indexOf('1066') !== -1 ||
        this.RoleID.indexOf('1068') !== -1 ||
        this.RoleID.indexOf('1069') !== -1 ||
        this.RoleID.indexOf('1070') !== -1 ||
        this.RoleID.indexOf('1063') !== -1
      );
      const isHandleViewer = false;
      return (isAudit && hasAuditRole) || (isView && canView) || isHandleViewer || this.gradingConsultDirectorViewAudit;
    },
    showRiskMonitorReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      const isView = !this.type || (this.type !== '1' && this.type !== '2');
      const hasAuditRole = this.RoleID && (this.RoleID.indexOf('1069') !== -1 || this.RoleID.indexOf('1068') !== -1 || this.RoleID.indexOf('1070') !== -1);
      const canView = this.RoleID && (this.RoleID.indexOf('1068') !== -1 || this.RoleID.indexOf('1069') !== -1 || this.RoleID.indexOf('1070') !== -1 || this.RoleID.indexOf('1063') !== -1);
      const isHandleViewer = isHandle && this.RoleID && (this.RoleID.indexOf('1068') !== -1 || this.RoleID.indexOf('1069') !== -1);
      return (isAudit && hasAuditRole) || (isView && canView) || isHandleViewer;
    },
    disabledConsultDirectorReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      if (isAudit) {
        return !(this.RoleID && this.RoleID.indexOf('1066') !== -1);
      }
      if (isHandle) return true;
      return true;
    },
    disabledRiskMonitorReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      if (this.gradingConsultDirectorViewAudit) return true;
      if (isAudit) {
        return !(this.RoleID && this.RoleID.indexOf('1069') !== -1);
      }
      if (isHandle) return true;
      return true;
    },
    showCriAdminReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      const isView = !this.type || (this.type !== '1' && this.type !== '2');
      const hasAuditRole = this.RoleID && (this.RoleID.indexOf('1068') !== -1 || this.RoleID.indexOf('1070') !== -1);
      const canView = this.RoleID && (this.RoleID.indexOf('1068') !== -1 || this.RoleID.indexOf('1069') !== -1 || this.RoleID.indexOf('1070') !== -1 || this.RoleID.indexOf('1063') !== -1);
      const isHandleViewer = isHandle && this.RoleID && (this.RoleID.indexOf('1068') !== -1 || this.RoleID.indexOf('1069') !== -1);
      return (isAudit && hasAuditRole) || (isView && canView) || isHandleViewer;
    },
    disabledCriAdminReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      if (this.gradingConsultDirectorViewAudit) return true;
      if (isAudit) {
        return !(this.RoleID && this.RoleID.indexOf('1068') !== -1);
      }
      if (isHandle) return true;
      return true;
    },
    showCenterDirectorReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      const isView = !this.type || (this.type !== '1' && this.type !== '2');
      const hasAuditRole = this.RoleID && this.RoleID.indexOf('1070') !== -1;
      const canView = this.RoleID && (this.RoleID.indexOf('1068') !== -1 || this.RoleID.indexOf('1069') !== -1 || this.RoleID.indexOf('1070') !== -1 || this.RoleID.indexOf('1063') !== -1);
      const isHandleViewer = isHandle && this.RoleID && (this.RoleID.indexOf('1068') !== -1 || this.RoleID.indexOf('1069') !== -1);
      return (isAudit && hasAuditRole) || (isView && canView) || isHandleViewer;
    },
    disabledCenterDirectorReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      if (this.gradingConsultDirectorViewAudit) return true;
      if (isAudit) {
        return !(this.RoleID && this.RoleID.indexOf('1070') !== -1);
      }
      if (isHandle) return true;
      return true;
    },
    // 判断是否显示提交和驳回按钮（type=1时，1069、1068、1070显示）
    showSubmitAndRejectBtns() {
      if (this.type !== '1') return false;
      const roles = ['1069', '1068', '1070', '1066'];
      return roles.some(role => this.RoleID && this.RoleID.indexOf(role) !== -1);
    },
    // 判断是否显示审核确认按钮（1068显示）
    showFinalSubmitBtn() {
      return this.RoleID && this.RoleID.indexOf('1068') !== -1 && this.type === '1';
    },
    // type=1（审核）时：不同角色对应不同“提交”按钮文案
    auditPrimarySubmitText() {
      if (!this.RoleID) return '审核确认';
      if (this.RoleID.indexOf('1066') !== -1) return '提交风险监控员';
      if (this.RoleID.indexOf('1069') !== -1) return '提交危机主管';
      if (this.RoleID.indexOf('1068') !== -1) return '提交中心主任';
      return '审核确认';
    },
    // 判断是否可以编辑风险等级（审核时，1069和1068可以编辑）
    canEditFirstCrisis() {
      // type=1（审核）时，1069和1068可以编辑
      if (this.type === '1') {
        return (this.RoleID && this.RoleID.indexOf('1069') !== -1) || 
               (this.RoleID && this.RoleID.indexOf('1068') !== -1) ||
               (this.RoleID && this.RoleID.indexOf('1066') !== -1) ||
               (this.RoleID && this.RoleID.indexOf('1070') !== -1);
      }
      // 其他情况不可编辑
      return false;
    }
  },
  mounted() {
    this.init();
  },
  methods:{
    // 关闭弹窗
    cancellation(done){
      var _this=this;
      this.$confirm('确认关闭？').then(_ => {
            done();
            _this.risiscasesData= _this.$options.data().risiscasesData;
            _this.crisiscasesdialog=false;
            _this.$parent.Init();
          }).catch(_ => {
            
          });
      },
      canceldia(){
        this.risiscasesData=this.$options.data().risiscasesData;
        this.crisiscasesdialog=false;
        this.$parent.Init();
      },
    // 自杀自伤伤害倾向选项
    handleCheckedDamageChange(value){
      this.risiscasesData.InjuryTendency=[];
      for(let item of value){
        let str=JSON.parse(item);
        if(str.cdicvalue=='其他'){
          str.dicKey+=','+this.Damageother;
          this.risiscasesData.InjuryTendency.push(str);
        }else{
          this.risiscasesData.InjuryTendency.unshift(str);
        }
      };
    },
    handleCheckedSuicideMethodsChange(value){
      this.risiscasesData.SuicideMethods=[];
      for(let item of value){
        let str=JSON.parse(item);
        if(str.cdicvalue=='其他'){
          str.dicKey+=','+this.SuicideMethodsother;
          this.risiscasesData.SuicideMethods.push(str);
        }else{
          this.risiscasesData.SuicideMethods.unshift(str);
        }
      }
    },
    handleCheckedSuspectedAppearChange(value){
      this.risiscasesData.SuspectedAppearance=[];
      for(let item of value){
        this.risiscasesData.SuspectedAppearance.push(JSON.parse(item))
      }
    },
    handleCheckedSensoryProblemsChange(value){
      this.risiscasesData.SensoryProblems=[];
      for(let item of value){
        this.risiscasesData.SensoryProblems.push(JSON.parse(item))
      }
    },
    handleCheckedThinkProblemsChange(value){
      this.risiscasesData.ThinkProblems = [];
      for(let item of value){
        this.risiscasesData.ThinkProblems.push(JSON.parse(item))
      }
    },
    // 预约记录页危机上报弹窗
    Detail(e,num){
      this.paramscrisis.keyNo=e.KeyNo;
      this.SourceFlg='4';
      this.pageNum=num;
      if(num==-1 ||num==-2){
        this.prefabricatedTableData(e.KeyNo);
      }
      this.init();
      this.isEdit=e.Tstate=="1"?true:false;
      this.risiscasesData.TeachID=e['ConUserName'];
      this.risiscasesData.RecordTime=e['ConsultTime'];
      this.risiscasesData.RealName=e['UserName'];
      this.UserName=e.UserName;
      this.risiscasesData.UserID=e['UserID'];
      this.risiscasesData.Phone=e['Phone'];
      this.risiscasesData.DeptName=e['DeptName'];
      this.risiscasesData.AppointmentID=e['AppointmentID'];
      this.crisiscasesdialog=true;
      if(e.Tstate!=null){
        this.consultationReport(e,num);
      }else{
        this.GetDictionaryList();
      }
    },
    // 危机上报页面危机上报弹窗
    CrisisreporDetail(e,num,type){
      this.paramscrisis.keyNo=e.KeyNo;
      this.paramscrisis.type=e.type;
      this.Tstate=e.Tstate;
      this.pageNum=num;
      this.type=type ; // 保存type参数
      // 获取operate值（如果传入的参数中有operate）
      // if(e.Tstate !== undefined && e.Tstate !== null && e.Tstate !== ''){
      //   this.paramscrisis.Operate = e.Tstate;
      // }else{
      //   this.paramscrisis.Operate = '';
      // }
      if(num==-1 ||num==-2){
        this.prefabricatedTableData(e.KeyNo);
      }
      this.init();
      this.isEdit=e.Tstate=="1" || this.RoleID!="1059"?true:false;
      this.crisiscasesdialog=true;;
      if(e.sourceNo!=null){
        this.ConsultationAndCrisisReport(e);
      }else{
        this.GetDictionaryList();
      }
    },

    // 驳回原因不可编辑
    Crisisreporreject(e,num){
      this.paramscrisis.keyNo=e.KeyNo;
      this.paramscrisis.type=e.type;
      this.Tstate=e.Tstate;
      this.pageNum=num;
      if(num==-1 ||num==-2){
        this.prefabricatedTableData(e.KeyNo);
      }
      this.init();
      this.isEdit=true;
      this.crisiscasesdialog=true;;
      if(e.sourceNo!=null){
        this.ConsultationAndCrisisReport(e);
      }else{
        this.GetDictionaryList();
      }
    },

    // 危机上报无法确定弹窗
    Unabledetermine(e,num){
      this.paramscrisis.keyNo=e.KeyNo;
      this.paramscrisis.type=e.type;
      this.Reporttype=e.type;
      this.pageNum=num;
      this.Tstate=e.Tstate;
      this.prefabricatedTableData(e.KeyNo);
      this.isEdit=e.Tstate=="1" || this.RoleID!="1059"?true:false;
      this.crisiscasesdialog=true;
      this.risiscasesData.TeachID=e['ConUserName'];
      this.risiscasesData.RecordTime=e['ConsultTime'];
      this.risiscasesData.RealName=e['UserName'];
      this.UserName=e.UserName;
      this.risiscasesData.UserID=e['UserID'];
      this.risiscasesData.Phone=e['Phone'];
      this.risiscasesData.DeptName=e['DeptName'];
      this.risiscasesData.AppointmentID=e['AppointmentID'];
      this.$Http_Post('/management/distressPrediction/ConsultationUnableConfirmData',{KeyNo:e.KeyNo}).then(res=>{
        if(res.Code==0){
          this.risiscasesData=res.Data;
          this.risiscasesData.RealName=e['realName'];
          this.risiscasesData.UserID=res.Data['UserID'];
          this.risiscasesData.SourceNo=e['sourceNo'];
          this.UserName=res.Data.UserName;
          this.risiscasesData.RecordTime=res.Data['ConsultTime'];
          this.risiscasesData.InjuryTendency=res.Data.InjuryTendencys;
          this.risiscasesData.SuspectedAppearance=res.Data.SuspectedAppearances;
          this.GetDictionaryList();
        }else{
          this.$message.error(res.Message);
        }
      });
    },

    // 危机上报咨询师评估
    Consultantevaluation(e){
      this.crisiscasesdialog=true;;
      this.estimate=false;
      this.risiscasesData.TeachID=e['ConsultantName'];
      this.risiscasesData['SourceFlag']=1;
      this.risiscasesData.Phone=e['Phone'];
      this.risiscasesData.RealName=e['realName'];
      this.risiscasesData.UserID=e['userId'];
      this.risiscasesData.SourceNo=e['sourceNo'];
      this.risiscasesData.KeyNo=e['KeyNo'];
      this.UserName=e.realName;
      this.risiscasesData.DeptName=e['deptName'];
      this.risiscasesData.EvaluationTime=this.Global.formatDate(new Date(),'YYYY-MM-DD HH:mm:ss');
      this.isEdit=e.reportStatus=='待咨询师评估'?false:true;
      this.GetDictionaryList();
    },

    // 危机干预咨询师评估
    interveneConsultantevaluation(e){
      this.crisiscasesdialog=true;;
      this.estimate=false;
      this.risiscasesData['SourceFlag']=2;
      this.risiscasesData.TeachID=e['ConsultantName'];
      this.risiscasesData.Phone=e['phone'];
      this.risiscasesData.RealName=e['RealName'];
      this.risiscasesData.UserID=e['UserId'];
      this.risiscasesData.SourceNo=e['SourceNo'];
      this.risiscasesData.KeyNo=e['KeyNo'];
      this.UserName=e.RealName;
      this.risiscasesData.DeptName=e['DeptName'];
      this.risiscasesData.EvaluationTime=this.Global.formatDate(new Date(),'YYYY-MM-DD HH:mm:ss');
      this.isEdit=e.RecordStatus=='待咨询师评估'?false:true;
      this.GetDictionaryList();
    },

    // 危机上报审核回显
    prefabricatedTableData(val){
      this.$Http_Post('management/distressPrediction/prefabricatedTableData',{keyNo:val}).then(res=>{
        if(res.Code==0 || res.Code==200){
          // this.paramscrisis=res.Data;
          this.reportStatus=res.Data.reportStatus;
          this.urgentStatus=res.Data.urgentStatus;
          this.SourceFlg=res.Data.SourceFlg;
          this.paramscrisis.consultDirectorChecks=res.Data.consultDirectorChecks==null?[]:res.Data.consultDirectorChecks;
          this.paramscrisis.consultDirectorCheckDetail=res.Data.consultDirectorCheckDetail==null?'':res.Data.consultDirectorCheckDetail;
          this.paramscrisis.criAdminChecks=res.Data.criAdminChecks;
          this.paramscrisis.criAdminCheckDetail=res.Data.criAdminCheckDetail;
          this.paramscrisis.centerDirectorChecks=res.Data.centerDirectorChecks;
          this.paramscrisis.centerDirectorCheckDetail=res.Data.centerDirectorCheckDetail;
          this.paramscrisis.riskMonitorChecks=res.Data.riskMonitorChecks;
          this.paramscrisis.riskMonitorCheckDetail=res.Data.riskMonitorCheckDetail;
          // 获取办理内容
          if (res.Data.CriAdminHandleDetail !== undefined) {
            this.criAdminHandleDetail = res.Data.CriAdminHandleDetail || '';
          }
          if (res.Data.RiskMonitorHandleDetail !== undefined) {
            this.riskMonitorHandleDetail = res.Data.RiskMonitorHandleDetail || '';
          }
          if (res.Data.RiskMonitorReviewDetail !== undefined) {
            this.riskMonitorReviewDetail = res.Data.RiskMonitorReviewDetail || '';
          }
          if (res.Data.CriAdminReviewDetail !== undefined) {
            this.criAdminReviewDetail = res.Data.CriAdminReviewDetail || '';
          }
          if (res.Data.CenterDirectorReviewDetail !== undefined) {
            this.centerDirectorReviewDetail = res.Data.CenterDirectorReviewDetail || '';
          }
          if (res.Data.ConsultDirectorReviewDetail !== undefined) {
            this.consultDirectorReviewDetail = res.Data.ConsultDirectorReviewDetail || '';
          }
          // 获取operate值（如果接口返回了operate）
          // if (res.Data.Operate !== undefined && res.Data.Operate !== null && res.Data.Operate !== '') {
          //   this.paramscrisis.Operate = res.Data.Operate;
          // }
        }
      });
    },
    //危机上报页面回显用
    ConsultationAndCrisisReport(e){
      this.$Http_Post('/management/distressPrediction/ConsultationAndCrisisReportData',{SourceNo:e.sourceNo}).then(res=>{
        if(res.Code==0){
          this.risiscasesData=res.Data;
          this.risiscasesData.RealName=e['realName'];
          this.risiscasesData.UserID=res.Data['UserID'];
          this.risiscasesData.SourceNo=e['sourceNo'];
          this.risiscasesData.InjuryTendency=res.Data.InjuryTendencys;
          this.risiscasesData.SuspectedAppearance=res.Data.SuspectedAppearances;
          this.UserName=res.Data.UserName;
          this.risiscasesData.RecordTime=res.Data['ConsultTime'];
          this.GetDictionaryList();
        }else{
          this.$message.error(res.Message);
        }
      })
    },
  // 预约记录页面回显用
    consultationReport(e,num){
          this.$Http_Post('/management/distressPrediction/consultationReportData/',{AppointmentID:e.AppointmentID}).then(res=>{
            if(res.Code==0){
              this.risiscasesData=res.Data;
              this.risiscasesData.AppointmentID=e['AppointmentID'];
              this.risiscasesData.InjuryTendency=res.Data.InjuryTendencys;
              this.risiscasesData.SuspectedAppearance=res.Data.SuspectedAppearances;
              this.risiscasesData.UserID=e['UserID'];
              this.risiscasesData.RecordTime=e['ConsultTime'];
              this.risiscasesData.Phone=e['Phone'];
              this.risiscasesData.DeptName=e['DeptName'];
              this.risiscasesData.RealName=res.Data['UserName'];
              this.risiscasesData.KeyNo=e.KeyNo;
              this.GetDictionaryList();
            }else{
              this.$message.error(res.Message);
            }
      })
    },

  //   获取字典表数据
    GetDictionaryList(){
      this.$Http_Post('/User/GetDictionaryList/',{DicTypCode:'31'}).then(res=>{
        if(res.Code==0){
          this.DamageList=res.Data;
          this.getSuicideMethods();
          if(this.risiscasesData.InjuryTendency!=undefined){
            for(var i=0;i<this.risiscasesData.InjuryTendency.length;i++){
              for(let list of res.Data){
                if(this.risiscasesData.InjuryTendency[i]==list.dicKey){
                  let str=`{"dicKey":"${list.dicKey}","cdicvalue":"${list.cDicValue}"}`;
                  if(list.cDicValue=='其他' && this.risiscasesData.InjuryTendency[i+1]){
                    this.Damageother=this.risiscasesData.InjuryTendency[i+1];
                  }
                  this.Damage.push(str);
                }
              }
            }
            this.handleCheckedDamageChange(this.Damage);
          }
        }
      });
    },

    getSuicideMethods(){
      this.$Http_Post('/User/GetDictionaryList/',{DicTypCode:'32'}).then(res=>{
        if(res.Code==0){
          this.SuicideMethodsList=res.Data;
          this.getSuspectedAppear();
          if(this.risiscasesData.SuicideMethodses!=undefined){
            for(var i=0;i<this.risiscasesData.SuicideMethodses.length;i++){
              for(let list of res.Data){
                if(this.risiscasesData.SuicideMethodses[i]==list.dicKey){
                  let str=`{"dicKey":"${list.dicKey}","cdicvalue":"${list.cDicValue}"}`;
                  if(list.cDicValue=='其他' && this.risiscasesData.SuicideMethodses[i+1]){
                    this.SuicideMethodsother=this.risiscasesData.SuicideMethodses[i+1];
                  }
                  this.SuicideMethods.push(str);
                }
              }
            }
            this.handleCheckedSuicideMethodsChange(this.SuicideMethods);
          }
        }
      });
    },

    //
    getSuspectedAppear(){
      this.$Http_Post('/User/GetDictionaryList/',{DicTypCode:'33'}).then(res=>{
        if(res.Code==0){
          this.SuspectedAppearList=res.Data;
          this.getSensoryProblems();
          if(this.risiscasesData.SuspectedAppearance!=undefined){
            for(let item of this.risiscasesData.SuspectedAppearance){
              for(let list of res.Data){
                if(item==list.dicKey){
                  let str=`{"dicKey":"${list.dicKey}","cdicvalue":"${list.cDicValue}"}`;
                  this.SuspectedAppear.push(str);
                }
              }
            }
            this.handleCheckedSuspectedAppearChange(this.SuspectedAppear);
          }
        }
      });
    },
    getSensoryProblems(){
      this.$Http_Post('/User/GetDictionaryList/',{DicTypCode:'34'}).then(res=>{
        if(res.Code==0){
          this.SensoryProblemsList = res.Data;
          
          this.getThinkProblems();
          if(this.risiscasesData.SensoryProblemses!=undefined){
            for(let item of this.risiscasesData.SensoryProblemses){
              for(let list of res.Data){
                if(item==list.dicKey){
                  let str=`{"dicKey":"${list.dicKey}","cdicvalue":"${list.cDicValue}"}`;
                  this.SensoryProblems.push(str);
                }
              }
            }
            this.handleCheckedSensoryProblemsChange(this.SensoryProblems);
          }
        }
      });
    },
    getThinkProblems(){
      this.$Http_Post('/User/GetDictionaryList/',{DicTypCode:'35'}).then(res=>{
        if(res.Code==0){
          this.ThinkProblemsList=res.Data;
          if(this.risiscasesData.ThinkProblemses!=undefined){
            for(let item of this.risiscasesData.ThinkProblemses){
              for(let list of res.Data){
                if(item==list.dicKey){
                  let str=`{"dicKey":"${list.dicKey}","cdicvalue":"${list.cDicValue}"}`;
                  this.ThinkProblems.push(str);
                }
              }
            }
            this.handleCheckedThinkProblemsChange(this.ThinkProblems);
          }
        }
      });
    },
    confirmClick(type){
      this.$refs['risiscasesData'].validate((valid) => {
          if (valid) {
            this.risiscasesData['Type']=type;
            this.$Http_Post('/DistressPrediction/ConsultationReport/',this.risiscasesData).then(res=>{
              if(res.Code==0){
                this.$message({
                  type: 'success',
                  message:res.Message,
                });
                this.crisiscasesdialog=false;
                this.$parent.Init();
              }else{
                this.$message({ type: 'error', message:res.Message});
              }
            });
          }else{
            this.$message({ type: 'warning', message:"请选择风险等级"});
          }
        });
      
    },
    // 审核意见
    // submit(val) {
    //   this.paramscrisis.Operate=val;
    //   this.$Http_Post('/DistressPrediction/DailyRiskMonitors',this.paramscrisis).then((res) => {
    //     if (res.Code == 200 || res.Code == 0) {
    //       this.$message({type: 'success',  message:res.Message});
    //       this.crisiscasesdialog=false;
    //       this.$parent.Init();
    //     }else{
    //       this.$message({type: 'error',  message:'提交失败'});
    //     }
    //   });
    // },
    // 驳回处理（带确认提示）
    handleReject() {
      this.$confirm('确认驳回该申请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleSubmit('0');
      }).catch(() => {
        // 用户取消操作
      });
    },
    // 审核提交处理（type=1时使用）
    handleSubmit(type) {
      // type: '1' 提交, '0' 驳回, '2' 最终提交 3咨询主管驳回咨询
      if (!this.paramscrisis.keyNo) {
        this.$message.warning('缺少关键参数');
        return;
      }
      
      const params = {
        keyNo: this.paramscrisis.keyNo,
        type: type, // 提交驳回标记
        sourceFlg: "4",//4：咨询上报
      };
      
      // 咨询的提交的提交状态，不传回把已上报1修改为未上报
      //params.operate = this.paramscrisis.Operate;
    
      // 根据角色决定是否传初评危机状态
      const editableRoles = ['1069', '1068', '1066', '1070'];
      const canEdit = editableRoles.some(role => this.RoleID && this.RoleID.indexOf(role) !== -1);
      
      if (canEdit && this.type === '1') {
        // 1069、1068 传初评危机状态（仅在审核时）
        if (!this.risiscasesData.FirstCrisis || this.risiscasesData.FirstCrisis == '0') {
          this.$message.warning('请选择风险等级');
          return;
        }
        params.firstCrisis = this.risiscasesData.FirstCrisis;
      }

      // 1066 咨询主管初审：审核意见为非必填；若填写则一并提交
      if (this.pageNum === -3 && this.RoleID && this.RoleID.indexOf('1066') !== -1 && (type === '1' || type === '3')) {
        const consultDirectorCheckDetail = (this.paramscrisis.consultDirectorCheckDetail || '').trim();
        if (consultDirectorCheckDetail) {
          params.consultDirectorCheckDetail = consultDirectorCheckDetail;
        }
        if (this.paramscrisis.consultDirectorChecks && this.paramscrisis.consultDirectorChecks.length) {
          params.consultDirectorChecks = this.paramscrisis.consultDirectorChecks;
        }else{
          params.consultDirectorChecks = [];
        }
      }

      // 定级审核：与 Crisis_lookreport 一致，随 UpdateFirstCrisis 提交（有内容再传）
      if (this.type === '1') {
        if (this.RoleID && this.RoleID.indexOf('1069') !== -1 && this.riskMonitorReviewDetail && this.riskMonitorReviewDetail.trim()) {
          params.RiskMonitorReviewDetail = this.riskMonitorReviewDetail.trim();
        }
        if (this.RoleID && this.RoleID.indexOf('1068') !== -1 && this.criAdminReviewDetail && this.criAdminReviewDetail.trim()) {
          params.CriAdminReviewDetail = this.criAdminReviewDetail.trim();
        }
        if (this.RoleID && this.RoleID.indexOf('1070') !== -1 && this.centerDirectorReviewDetail && this.centerDirectorReviewDetail.trim()) {
          params.CenterDirectorReviewDetail = this.centerDirectorReviewDetail.trim();
        }
        if (this.RoleID && this.RoleID.indexOf('1066') !== -1 && this.consultDirectorReviewDetail && this.consultDirectorReviewDetail.trim()) {
          params.ConsultDirectorReviewDetail = this.consultDirectorReviewDetail.trim();
        }
      }
      
      this.$Http_Post('/DistressPrediction/UpdateFirstCrisis', params).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.$message.success(res.Message || '操作成功');
          this.crisiscasesdialog = false;
          this.$parent.Init();
        } else {
          this.$message.error(res.Message || '操作失败');
        }
      }).catch((err) => {
        this.$message.error('操作失败');
      });
    },
    // 办理提交处理（type=2时使用）
    handleHandleSubmit() {
      if (!this.paramscrisis.keyNo) {
        this.$message.warning('缺少关键参数');
        return;
      }
      
      const params = {
        keyNo: this.paramscrisis.keyNo,
        type: '2', // 办理标记
      };
      
      // 如果paramscrisis中有operate值，加上operate参数
      // if (this.paramscrisis.Operate !== undefined && this.paramscrisis.Operate !== null && this.paramscrisis.Operate !== '') {
      //   params.operate = this.paramscrisis.Operate;
      // }
      
      // 根据角色添加不同的办理内容字段
      if (this.RoleID && this.RoleID.indexOf('1068') !== -1) {
        // 1068: 危机主管办理内容
        if (!this.criAdminHandleDetail || !this.criAdminHandleDetail.trim()) {
          this.$message.warning('请输入危机主管办理内容');
          return;
        }
        params.criAdminHandleDetail = this.criAdminHandleDetail.trim();
      } else if (this.RoleID && this.RoleID.indexOf('1069') !== -1) {
        // 1069: 风险监控员办理内容
        if (!this.riskMonitorHandleDetail || !this.riskMonitorHandleDetail.trim()) {
          this.$message.warning('请输入风险监控员办理内容');
          return;
        }
        params.riskMonitorHandleDetail = this.riskMonitorHandleDetail.trim();
      }
      
      this.$Http_Post('/DistressPrediction/HandleCrisis', params).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.$message.success(res.Message || '办理提交成功');
          this.crisiscasesdialog = false;
          this.$parent.Init();
        } else {
          this.$message.error(res.Message || '办理提交失败');
        }
      }).catch((err) => {
        this.$message.error('办理提交失败');
      });
    },
    init(){
      this.Damage=[]
      this.DamageList=[]
      this.Damageother=''
      this.SuicideMethods=[]
      this.SuicideMethodsList=[]
      this.SuicideMethodsother=''
      this.SuspectedAppear=[]
      this.SuspectedAppearList=[]
      this.SensoryProblems=[]
      this.SensoryProblemsList=[]
      this.ThinkProblems=[]
      this.ThinkProblemsList=[]
      this.risiscasesData.InjuryTendency=[];
      this.risiscasesData.SuicideMethods=[];
      this.risiscasesData.SuspectedAppear=[];
      this.risiscasesData.SensoryProblems=[];
      this.risiscasesData.ThinkProblems=[];
      this.risiscasesData=this.$options.data().risiscasesData;
      this.criAdminHandleDetail = '';
      this.riskMonitorHandleDetail = '';
      this.riskMonitorReviewDetail = '';
      this.criAdminReviewDetail = '';
      this.centerDirectorReviewDetail = '';
    }
  }
}

</script>
<style scoped>
.el-form-item{margin:0;line-height: 30px;}
.el-textarea__inner{width: 100%!important;}
.AppointmentList .el-dialog__body .el-form-item__content span{margin-left: 0!important;}
.el-row{margin: 0;}
.nkjs .el-textarea.is-disabled .el-textarea__inner {
  width: 100% !important;
  height: 80px;
}
.nkjs .el-textarea .el-textarea__inner {
  width: 100% !important;
  height: 80px;
}
</style>